export const INFLUENCER_RESOURCE = 'influencer';
export const INFLUENCER_LINK_RESOURCE = 'influencerLink';
export const ORGANISATION_RESOURCE = 'organisations';
export const DATA_REQUESTS_RESOURCE = 'dataRequests';



/** WEBPACK FOOTER **
 ** ./src/utils/helpers/resources.js
 **/